import React, { FC, HTMLAttributes } from 'react';
import { cn } from '@/lib/utils.ts';

const ModalContent: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  return (
    <div {...props} className={cn('space-y-4 px-4 py-3', props.className)} />
  );
};

export default ModalContent;
